/* ============================================================
   Fence Works — calendar-date helpers
   `localYmd` is the LOCAL-timezone YYYY-MM-DD (what a user means by
   "today" on the schedule). `new Date().toISOString().slice(0, 10)`
   is UTC and rolls to tomorrow in the evening for anyone west of
   Greenwich — never use it for a calendar date. True instants
   (createdAt, `at: Date.now()`, ISO timestamps) are unaffected.
   ============================================================ */
export function localYmd(d: Date = new Date()): string {
  const y = d.getFullYear(), m = d.getMonth() + 1, day = d.getDate();
  return y + "-" + String(m).padStart(2, "0") + "-" + String(day).padStart(2, "0");
}
